import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=d705e7cc&"
import script from "./InventoryReport.vue?vue&type=script&lang=js&"
export * from "./InventoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports